import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { SavedQueryType } from '../../../../types';
import { TRANS_KEY_FAVORITES } from '../../data';

export type FavoritesGroupSectionPropsType = {
  activeFavorite?: SavedQueryType;
};

export const FavoritesGroupSection: React.FC<
  FavoritesGroupSectionPropsType
> = ({ activeFavorite }) => {
  const { t } = useTranslation();

  return (
    <Button.GroupSection
      fw={activeFavorite ? 700 : 400}
      variant="outline"
      styles={{
        groupSection: {
          color: 'var(--mantine-color-text)',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      }}
    >
      {activeFavorite?.name ?? t(`${TRANS_KEY_FAVORITES}.LABEL`)}
    </Button.GroupSection>
  );
};
